import React from 'react'
import loadable from '@loadable/component'
import PluginLoader from '~/components/plugin-loader';

export const PLUGIN_SELECTOR = '[data-ec-plugin], [data-gfy-plugin]';

export const BUY_BUTTON_KEY = 'buy-button';
export const VIDEO_PLAYER_KEY = 'video-player';
export const VIDEO_EMBED_KEY = 'video-embed';
export const AUTH_KEY = 'auth';

export const LoadableBuyButton = loadable(() => import(/* webpackChunkName: "buy-button" */ './buy-button'), {fallback: <PluginLoader/>});
export const LoadableVideoPlayer = loadable(() => import(/* webpackChunkName: "video" */ './video'), {fallback: <PluginLoader/>});
export const LoadableAuth = loadable(() => import(/* webpackChunkName: "auth" */ './auth'), {fallback: <PluginLoader/>});
export const LoadableVideoEmbed = loadable(() => import(/* webpackChunkName: "video-embed" */ './video-embed'), {fallback: <PluginLoader/>});


export const getProps = (plugin, node) => {
  return Object.assign({}, {
    gfyPlugin: node.dataset.gfyPlugin || node.dataset.ecPlugin,
    productId: node.dataset.productId,
    videoId: node.dataset.videoId,
    showPrice: (node.dataset.showPrice || node.dataset.showPrice === ''),
    showPriceBox: (node.dataset.showPriceBox || node.dataset.showPriceBox === ''),
    largePriceBox: (node.dataset.largePriceBox || node.dataset.largePriceBox === ''),
    buttonColor: (node.dataset.buttonColor),
    extraProducts: (node.dataset.extraProducts),
    textColor: (node.dataset.textColor),
    text: (node.dataset.text),
    type: (node.dataset.type),
    hideBuyButton: (node.dataset.hideBuyButton || node.dataset.hideBuyButton === ''),
    hideVideo: (node.dataset.hideVideo || node.dataset.hideVideo === ''),
    videoAccessKey: node.dataset.videoAccessKey,
  });
};

export const plugins = {
  [BUY_BUTTON_KEY]: {
    Component: LoadableBuyButton,
  },
  [VIDEO_PLAYER_KEY]: {
    Component: LoadableVideoPlayer,
  },
  [AUTH_KEY]: {
    Component: LoadableAuth,
  },
  [VIDEO_EMBED_KEY]: {
    Component: LoadableVideoEmbed,
  }
};
